/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { getDefaultOptions } from '@atlassian/jira-fetch/src/utils/fetch-default-options.tsx';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const logEmauForJira = (subproduct: string, url: any, urlParams: any) => {
	const body = JSON.stringify({
		eventData: { url, subproduct, urlParams },
	});

	const endpointUrl = '/rest/internal/2/log/unsafe/emau';
	const fetchOptions = {
		...getDefaultOptions(endpointUrl),
		method: 'POST',
		body,
	};

	return fetch(endpointUrl, fetchOptions);
};

export const logEmau = ({ product, subproduct }: { product: string; subproduct: string }): void => {
	if (product === 'jira') {
		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		logEmauForJira(subproduct, window.location.pathname, window.location.search);
	}
};
